export default "__VITE_ASSET__C8nol31J__"